import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoCloudLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M43.8035 32.5898C43.5402 24.2114 36.6662 17.5 28.2239 17.5C19.7816 17.5 12.9077 24.2114 12.6443 32.5898C5.77457 32.6497 0.223877 38.2362 0.223877 45.1201C0.223877 52.0412 5.89257 56 12.8137 56C16.9877 56 39.5761 56 43.75 56C50.6711 56 56.2239 52.0412 56.2239 45.1201C56.2239 38.2362 50.6733 32.6497 43.8035 32.5898ZM38.4019 42.586C37.2083 43.7797 35.2737 43.7805 34.0793 42.586C32.8849 41.3915 30.9137 39.4204 30.9137 39.4204V46.7989C30.9137 48.487 29.5452 49.8555 27.857 49.8555C26.1688 49.8555 24.8005 48.487 24.8005 46.7989V39.4203L21.6348 42.586C20.4412 43.7797 18.506 43.7797 17.3122 42.586C16.1185 41.3924 16.1185 39.4571 17.3122 38.2635C26.3652 29.2105 25.7128 29.8578 25.8351 29.75C27.0527 28.6746 28.8848 28.7462 30.0184 29.88C31.152 31.0137 37.208 37.0698 38.4018 38.2635C39.5955 39.4571 39.5955 41.3924 38.4019 42.586Z",
		fill: "#0578BE"
	})]
});
const ForwardRef = forwardRef(SvgIcoCloudLink);
export { ForwardRef as ReactComponent };
